<script lang="ts">
    export let open:boolean = false;
    import { fade } from 'svelte/transition';
    import Backdrop from '../components/backdrop.svelte';
</script>

<dialog open={open} transition:fade={{duration: 150}} >
    <slot></slot>
</dialog>

<style>
    dialog {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: calc(100% - 4rem);
        max-width: 512px;
        border-radius: 8px;
        color: var(--text);
        background: var(--background);
        border: 1px solid var(--background-offset);
        padding: 1rem;
        box-shadow: 0px 9px 11px rgba(0, 0, 0, 0.1), 0px 6px 0px rgba(0, 0, 0, 0.1);
        z-index: 10;
        margin: 0;
    }
    :global(.modal-button-group) {
        display: grid;
        grid-template-columns: auto auto;
        justify-content: end;
        column-gap: 1rem;
    }

</style>